<template>
  <div class="list-container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="page-title">未請求情報一覧</h1>
      <div>
        <router-link :to="{ name: 'BillingList' }"> <!-- 未請求作業一覧へのリンク -->
          <button type="button" class="btn btn-primary mx-1">請求書一覧へ</button>
        </router-link>
        <router-link :to="{ name: 'Home' }"> <!-- ホームへのリンク -->
          <button type="button" class="btn btn-primary mx-1">ホーム</button>
        </router-link>
      </div>
    </div>

    <!-- 検索バーの追加 -->
    <form class="search-container p-3 my-3" style="background-color: #f8f9fa;" @submit.prevent="searchNonMonthlyBillings"> <!-- 背景色を薄く設定 -->
      <div class="row g-3 align-items-center">
        <div class="d-flex align-items-center mb-2 me-2 flex-wrap">
          <div class="me-2">
            <label class="col-form-label">請求年月</label>
          </div>
          <div class="d-flex align-items-center me-3">
            <select id="searchYear" class="form-select" v-model="searchYear" placeholder="年で検索">
              <option value="" disabled selected>選択してください</option> <!-- placeholder -->
              <option v-for="year in years" :key="year" :value="year">{{ year }}年</option>
            </select>

            <select id="searchMonth" class="form-select ms-2" v-model="searchMonth" placeholder="月で検索">
              <option value="" disabled selected>選択してください</option> <!-- placeholder -->
              <option v-for="month in months" :key="month" :value="month">{{ month }}月</option>
            </select>
          </div>

          <!-- 顧客検索 -->
          <!-- <div class="d-flex align-items-center my-2 me-3">
            <div class="col-auto">
              <CustomerSelectBox
                v-model="searchCustomerName"
                :options="customers"
                placeholder="顧客名で検索"
                :formatter="c => c.customer_nm"
              />
            </div>
          </div> -->

          <div class="d-flex align-items-center my-2 me-3">
            <div class="col-auto">
              <input type="text" id="searchCustomerName" class="form-control" v-model="searchCustomerName" placeholder="顧客名で検索">
            </div>
          </div>

          <!-- 建物検索 -->
          <div class="d-flex align-items-center my-2 me-3">
            <div class="col-auto">
              <BuildingSelectBox
                v-model="searchBuildingName"
                :options="buildings"
                placeholder="建物名で検索"
                :formatter="b => b.building_nm"
              />
            </div>
          </div>

          <!-- 請求締日検索（選択ボックス） -->
          <div class="d-flex align-items-center my-2 me-3">
            <select class="form-select" v-model="searchBillingDeadline">
              <option value="">請求締日を選択</option>
              <option value="0">5日</option>
              <option value="1">10日</option>
              <option value="2">15日</option>
              <option value="3">20日</option>
              <option value="4">25日</option>
              <option value="5">月末</option>
            </select>
          </div>

          <div class="me-3">
            <button type="submit" class="btn btn-primary mx-1">検索</button>
            <button type="button" class="btn btn-secondary mx-1" @click="searchResetNonMonthlyBillings">クリア</button>
          </div>
        </div>
      </div>
    </form>

    <button
      type="button"
      class="btn btn-primary my-2"
      @click="submitSelection"
      :disabled="selectedAnnualWorkIds?.length == 0 && selectedTempWorkIds?.length == 0"
    >
      請求書作成
    </button>

    <!-- 横並びの枠組み -->
    <div class="d-flex gap-4 flex-wrap">
      <!-- 左側 年間予定作業テーブル -->
      <div class="flex-fill" style="width: 45%">
        <h4 class="mb-1">未請求の年間予定作業</h4>
        <span class="text-danger">※定額請求のものは合計金額が定額で表示されます</span>
        <div class="table-wrapper">
          <div class="table-wrapper">
            <table class="table table-bordered table-hover">
              <thead class="annual-work-table-header">
                <tr>
                  <th class="th-sticky sticky-left">
                    <label :for="`annual_work_check_all`" class="ECM_CheckboxInput-sm">
                      <input
                        type="checkbox"
                        :id="`annual_work_check_all`"
                        :checked="selectedAnnualWorkIds.length === annualWorkBuildings.length"
                        class="ECM_CheckboxInput-Input-sm"
                        @click="toggleAnnualAllSelection"
                      />
                      <span class="ECM_CheckboxInput-DummyInput-sm"></span>
                    </label>
                  </th>
                  <th class="text-nowrap">建物名</th>
                  <th class="text-nowrap">建物種別</th>
                  <th class="text-nowrap">顧客名</th>
                  <th class="text-nowrap">定額請求</th>
                  <th class="text-nowrap">合計</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="annualWorkBuilding in annualWorkBuildings"
                  :key="annualWorkBuilding.id"
                  :class="{ 'selected-row': selectedAnnualWorkIds?.includes(annualWorkBuilding.id) }"
                  @click="toggleAnnualSelection(annualWorkBuilding.id)"
                >
                  <td class="text-nowrap th-sticky sticky-left">
                    <label :for="`annual_work_check_${annualWorkBuilding.id}`" class="ECM_CheckboxInput-sm">
                      <input
                        type="checkbox"
                        :value="annualWorkBuilding.id"
                        v-model="selectedAnnualWorkIds"
                        :id="`annual_work_check_${annualWorkBuilding.id}`"
                        class="ECM_CheckboxInput-Input-sm"
                        @click="toggleAnnualSelection(annualWorkBuilding.id)"
                      />
                      <span class="ECM_CheckboxInput-DummyInput-sm"></span>
                    </label>
                  </td>
                  <td class="text-nowrap text-start">{{ annualWorkBuilding.building_nm }}</td>
                  <td class="text-nowrap text-start">{{ annualWorkBuilding?.m_building_type?.building_type_nm }}</td>
                  <td class="multiline-text text-start">{{ annualWorkBuilding?.m_customer?.customer_nm }}</td>
                  <td class="text-nowrap text-start">
                    {{
                      {
                        true: "対象",
                        false: "",
                      }[annualWorkBuilding.fixed_fee_billing]
                    }}
                  </td>
                  <td class="text-nowrap text-end">{{ formatCurrency(annualWorkBuilding?.total_bill_amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 右側 臨時作業テーブル-->
      <div class="flex-fill" style="width: 45%">
        <h4 class="mb-1">未請求の臨時作業</h4>
        <span class="text-danger">※検索の請求年月に含まれ、作業実施登録がされている情報が表示されます</span>
        <div class="table-wrapper">
          <!-- ここに臨時作業のテーブル -->
          <div class="table-wrapper">
            <table class="table table-bordered table-hover">
              <thead class="temporary-work-table-header">
                <tr>
                  <th class="th-sticky sticky-left">
                    <label :for="`temporary_work_check_all`" class="ECM_CheckboxInput-sm">
                      <input
                        type="checkbox"
                        :id="`temporary_work_check_all`"
                        :checked="selectedTempWorkIds.length === temporaryWorks.length"
                        class="ECM_CheckboxInput-Input-sm"
                        @click="toggleTemporaryAllSelection"
                      />
                      <span class="ECM_CheckboxInput-DummyInput-sm"></span>
                    </label>
                  </th>
                  <th class="text-nowrap th-sticky sticky-left-second">請求入力No.</th>
                  <th class="text-nowrap">見積書No.</th>
                  <th class="text-nowrap">顧客名</th>
                  <th class="text-nowrap">建物名</th>
                  <th class="text-nowrap">業務区分</th>
                  <th class="text-nowrap">業務内容</th>
                  <th class="text-nowrap">顧客名(請求先)</th>
                  <th class="text-nowrap">顧客担当者</th>
                  <th class="text-nowrap">受注日</th>
                  <th class="text-nowrap">受注金額(税抜)</th>
                  <th class="text-nowrap">作業日</th>
                  <th class="text-nowrap">当社担当者</th>
                  <th class="text-nowrap">請求発行依頼(担当者記入)</th>
                  <th class="text-nowrap">請求月</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="temporaryWork in temporaryWorks"
                  :key="temporaryWork.id"
                  :class="{ 'selected-row': selectedTempWorkIds?.includes(temporaryWork.id) }"
                  @click="toggleTempSelection(temporaryWork.id)"
                >
                  <td class="text-nowrap th-sticky sticky-left">
                    <label :for="`temporary_work_check_${temporaryWork.id}`" class="ECM_CheckboxInput-sm">
                      <input
                        type="checkbox"
                        :value="temporaryWork.id"
                        v-model="selectedTempWorkIds"
                        :id="`temporary_work_check_${temporaryWork.id}`"
                        class="ECM_CheckboxInput-Input-sm"
                        @click="toggleTempSelection(temporaryWork.id)"
                      />
                      <span class="ECM_CheckboxInput-DummyInput-sm"></span>
                    </label>
                  </td>
                  <td class="text-nowrap th-sticky sticky-left-second">{{ temporaryWork.billing_no }}</td>
                  <td class="text-nowrap">{{ temporaryWork.quotion_no }}</td>
                  <td class="multiline-text">{{ temporaryWork.m_customer?.customer_nm }}</td>
                  <td class="text-nowrap">{{ temporaryWork.m_building?.building_nm }}</td>
                  <td class="text-nowrap">{{ temporaryWork.m_business_classification?.business_classification_nm }}</td>
                  <td class="text-nowrap">{{ temporaryWork.work_content }}</td>
                  <td class="text-nowrap">{{ temporaryWork.m_customer_representative?.m_customer?.customer_nm }}</td>
                  <td class="text-nowrap">
                    {{ temporaryWork.m_customer_representative?.in_charge_last_nm }} 
                    {{ temporaryWork.m_customer_representative?.in_charge_first_nm }}
                  </td>
                  <td class="text-nowrap">{{ formatYearMonthDay(temporaryWork.order_dt) }}</td>
                  <td class="text-nowrap text-end">{{ formatCurrency(temporaryWork.order_amount) }}</td>
                  <td class="text-nowrap">{{ formatYearMonthDay(temporaryWork.work_dt) }}</td>
                  <td class="text-nowrap">{{ temporaryWork.company_representative }}</td>
                  <td class="text-nowrap">{{ temporaryWork.billing_request }}</td>
                  <td class="text-nowrap">{{ temporaryWork.billing_month }}月</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getNonMonthlyBillings,
  getSelectBoxCustomers,
  getSelectBoxBuildings
 } from '@/api/axios';
// import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue';
import BuildingSelectBox from '@/components/searchSelectBoxes/BuildingSelectBox.vue';

export default {
  components: {
    // CustomerSelectBox,
    BuildingSelectBox,
  },
  setup(_, { emit }) {
    const title = ref('月別未請求情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const router = useRouter();
    const route = useRoute();
    const customers = ref([]);
    const buildings = ref([]);
    const annualWorkBuildings = ref([]);
    const selectedAnnualWorkIds = ref([]);
    const temporaryWorks = ref([]);
    const selectedTempWorkIds = ref([]);
    const years = ref([]);
    const months = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    const targetYear = ref('');
    const targetMonth = ref('');

    // 現在の年月を取得
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      years.value.push(i);
    }

    targetYear.value = route.query.year ? parseInt(route.query.year, 10) : currentYear;
    targetMonth.value = route.query.month ? parseInt(route.query.month, 10) : currentMonth;

    // 検索用のデータプロパティ
    const searchYear = ref('');
    const searchMonth = ref('');
    const searchCustomerName = ref('');
    const searchBuildingName = ref('');
    const searchBillingDeadline = ref('');
    searchYear.value = targetYear.value;
    searchMonth.value = targetMonth.value;

    const getSearchQuery = () => ({
      year: searchYear.value || '',
      month: searchMonth.value || '',
      customer_nm: searchCustomerName.value || '',
      building_id: searchBuildingName.value || '',
      billing_deadline: searchBillingDeadline.value || ''
    });

    const fetchNonBillings = async () => {
      try {
        const response = await getNonMonthlyBillings({
          year: targetYear.value,
          month: targetMonth.value,
          customer_nm: searchCustomerName.value,
          building_id: searchBuildingName.value,
          billing_deadline: searchBillingDeadline.value,
        });
        annualWorkBuildings.value = response.data.annual_works;
        temporaryWorks.value = response.data.temporary_works;
      } catch (error) {
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      try {
        const response = await getSelectBoxCustomers();
        customers.value = response.data;
      } catch (error) {
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }

      // 建物情報（検索用）
      try {
        const response = await getSelectBoxBuildings();
        buildings.value = response.data;
      } catch (error) {
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }
    };

    // 検索処理
    const searchNonMonthlyBillings = () => {
      router.push({
        path: '/monthly-non-billings',
        query: getSearchQuery(),
      });
    };

    // リセット処理
    const searchResetNonMonthlyBillings = () => {
      searchYear.value = '';
      searchMonth.value = '';
      searchCustomerName.value = '';
      searchBuildingName.value = '';
      searchBillingDeadline.value = '';

      router.replace({
        path: '/monthly-non-billings',
        query: getSearchQuery(),
      });
    };

    // クエリパラメータの監視（画面遷移後の自動反映）
    watch(
      () => route.query,
      (newQuery) => {
        searchYear.value = newQuery.year || new Date().getFullYear(); // クエリがない場合は空にする
        searchMonth.value = newQuery.month || new Date().getMonth() + 1; // クエリがない場合は空にする
        searchCustomerName.value = newQuery.customer_nm || ''; // クエリがない場合は空にする
        searchBuildingName.value = newQuery.building_id || ''; // クエリがない場合は空にする
        searchBillingDeadline.value = newQuery.billing_deadline || ''; // クエリがない場合は空にする

        targetYear.value = searchYear.value;
        targetMonth.value = searchMonth.value;

        // データ再取得
        fetchNonBillings();
      },
      { immediate: true } // 初回に即座に実行
    );

    // 年間予定作業の全て選択
    const toggleAnnualAllSelection = () => {
      if (selectedAnnualWorkIds.value.length === annualWorkBuildings.value.length) {
        selectedAnnualWorkIds.value = [];
      } else {
        selectedAnnualWorkIds.value = annualWorkBuildings.value.map(b => b.id);
      }
    };

    // 年間予定作業の選択保持
    const toggleAnnualSelection = (workId) => {
      const index = selectedAnnualWorkIds.value.indexOf(workId);
      if (index === -1) {
        // 選択されていない場合は追加
        selectedAnnualWorkIds.value = [...selectedAnnualWorkIds.value, workId];
      } else {
        // 選択されている場合は削除
        selectedAnnualWorkIds.value = selectedAnnualWorkIds.value.filter(id => id !== workId);
      }
    };

    // 臨時作業の全て選択
    const toggleTemporaryAllSelection = () => {
      if (selectedTempWorkIds.value.length === temporaryWorks.value.length) {
        selectedTempWorkIds.value = [];
      } else {
        selectedTempWorkIds.value = temporaryWorks.value.map(b => b.id);
      }
    };

    // 臨時作業の選択保持
    const toggleTempSelection = (workId) => {
      const index = selectedTempWorkIds.value.indexOf(workId);
      if (index === -1) {
        // 選択されていない場合は追加
        selectedTempWorkIds.value = [...selectedTempWorkIds.value, workId];
      } else {
        // 選択されている場合は削除
        selectedTempWorkIds.value = selectedTempWorkIds.value.filter(id => id !== workId);
      }
    };

    const submitSelection = () => {
      const selectedAnnualWorks = annualWorkBuildings.value.filter((work) =>
        selectedAnnualWorkIds.value?.includes(work.id)
      );

      const selectedTempWorks = temporaryWorks.value.filter((work) =>
        selectedTempWorkIds.value?.includes(work.id)
      );

      console.log('選択された年間予定作業:', selectedAnnualWorks);
      console.log('選択された臨時作業:', selectedTempWorks);

      emit('onSelect', {
        annual: selectedAnnualWorks,
        temp: selectedTempWorks,
      });

      router.push({
        path: `/monthly-billing-create/${targetYear.value}/${targetMonth.value}`,
        query: {
          ...getSearchQuery(),
          annual_work_ids: selectedAnnualWorkIds.value.map(String),
          temporaly_work_ids: selectedTempWorkIds.value.map(String),
        },
      });
    };

    const formatYearMonthDay = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    };

    // Format currency
    const formatCurrency = (value) => {
      if (value) {
        return new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY',
        }).format(value);
      }
      return '¥0';
    };

    return {
      title,
      customers,
      buildings,
      annualWorkBuildings,
      temporaryWorks,
      years,
      months,
      targetYear,
      targetMonth,
      fetchNonBillings,
      searchYear,
      searchMonth,
      searchCustomerName,
      searchBuildingName,
      searchBillingDeadline,
      getSearchQuery,
      searchNonMonthlyBillings,
      searchResetNonMonthlyBillings,
      toggleAnnualAllSelection,
      toggleAnnualSelection,
      toggleTemporaryAllSelection,
      toggleTempSelection,
      selectedAnnualWorkIds,
      selectedTempWorkIds,
      submitSelection,
      formatYearMonthDay,
      formatCurrency
    };
  }
};
</script>

<style scoped>
.building-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.building-item:hover {
  background-color: #f5f5f5;
}

.table-wrapper {
  background: #fff;
  border: 1px solid #BBBBBB;
  width: 100%;
  overflow-x: scroll;
}

.table-wrapper table{
  margin-bottom: 0;
}

.annual-work-table-header th {
  background: #005e66 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
  color: #fff !important;
}

.temporary-work-table-header th {
  background: #662c00 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
  color: #fff !important;
}

table th,
table td{
  font-size: 14px;
}

.table-wrapper .sticky-left {
  position: sticky;
  z-index: 100;
  border-left: none;
  left: 0;
}
.table-wrapper .sticky-left:before,
.table-wrapper .sticky-left:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-right: 1px solid #DEE2E6;
  z-index: 99;
}
.table-wrapper .sticky-left:before,
.table-wrapper .sticky-left:after,
.table-wrapper .sticky-left {
  min-width: 64px;
  width: 64px;
  max-width: 64px;
}
.status-no-billing td {
  background-color: #FFD5EC !important;
  color: #ff0000;
}

.status-no-sending td {
  background-color: #FFDBC9 !important;
  color: #000;
}

.status-no-schedule td {
  background-color: #CCFFCC !important;
  color: #000;
}

.status-no-confirm td {
  background-color: #FFFFCC !important;
  color: #000;
}

.status-all-ok td {
  background-color: #E6FFE9 !important;
  color: #000;
}

.selected-row{
  cursor: pointer;
}

.selected-row td {
  background-color: #f0f8ff;
}
</style>
